<template>
    <li>
        <a :href="cafeUrl" target="_blank" class="link_item">
            <div class="thumb_g"><img :src="profileImage" width="40" height="40" alt=""></div>
            <div class="desc_item">
                <strong class="tit_item">{{starName}}</strong>
                <span v-if="official" class="ico_cafetop ico_emblum">공식</span>
                <ul class="list_info">
                    <li>랭킹 {{ rank }}</li>
                    <li>회원 {{ memberCount.toLocaleString() }}</li>
                </ul>
            </div>
        </a>
    </li>
</template>

<script>
export default {
    props: {
        starName: String,
        official: Boolean,
        cafeUrl: String,
        profileImage: String,
        memberCount: {
            type: Number,
            default: 0
        },
        rank: Number
    }
}
</script>
